/* global pbContactForm */

window.addEventListener('load', function () {
	const modal = document.getElementById('grading-issues-modal');
	const btn = document.getElementById('grading-issues-btn');
	const closeBtn = document.getElementsByClassName('close')[0];
	let lastFocusedBeforeOpen = null;

	if(btn === null) {
		return;
	}

	function openModal() {
		if (modal.open) return;
		lastFocusedBeforeOpen = document.activeElement;
		document.getElementById('grading-issues-form').style.display = 'block';
		document.getElementById('contact-form-success-message').style.display = 'none';
		document.getElementById('contact-form-error-message').style.display = 'none';
		modal.showModal();
		
		requestAnimationFrame(() => {
			const firstControl = modal.querySelector('#grading-issues-form input:not([type="hidden"]):not([disabled]), #grading-issues-form select:not([disabled]), #grading-issues-form textarea:not([disabled])');
			if (firstControl && typeof firstControl.focus === 'function') {
				firstControl.focus({ preventScroll: true });
			}
		});
	}

	function closeModal() {
		if (!modal.open) return;
		modal.close();
		if (lastFocusedBeforeOpen && typeof lastFocusedBeforeOpen.focus === 'function') {
			lastFocusedBeforeOpen.focus();
		} else if (btn) {
			btn.focus();
		}
	}

	btn.onclick = function () {
		openModal();
	}

	closeBtn.onclick = function () {
		closeModal();
	}

	closeBtn.onkeydown = function (event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			closeModal();
		}
	}

	modal.addEventListener('click', (event) => {
		if (event.target === modal) {
			closeModal();
		}
	});

	const form = document.getElementById('grading-issues-form');

	form.onsubmit = function (event) {
		event.preventDefault();

		document.getElementById('contact-form-submit').disabled = true;

		fetch(pbContactForm.ajaxUrl, {
			method: form.method,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams(new FormData(form)),
		}).then(response => {
			document.getElementById('grading-issues-form').style.display = 'none';
			const messageClass = response.ok ? 'contact-form-success-message' : 'contact-form-error-message';
			document.getElementById(messageClass).style.display = 'block';
			document.getElementById('contact-form-submit').disabled = false;
		}).catch(error => {
			document.getElementById('grading-issues-form').style.display = 'none';
			document.getElementById('contact-form-submit').disabled = false;
			document.getElementById('contact-form-error-message').style.display = 'block';
		});

	}
});
